<crowdctrl-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/">
  @if (isLoading) {
    <crowdctrl-loading-card message="Loading accounts..."></crowdctrl-loading-card>
  } @else if (hasLoadedOnce && availableTenants.length === 0) {
    <div style="text-align: center; padding: 2rem">
      <p>No accounts available.</p>
    </div>
  } @else if (hasLoadedOnce) {
    <crowdctrl-list>
      @for (tenant of availableTenants; track tenant.id) {
        <ion-item button detail (click)="selectTenant(tenant.id)">
          <ion-thumbnail slot="start" class="tenant-thumbnail">
            <div class="thumbnail-placeholder"></div>
          </ion-thumbnail>
          <ion-label>
            <h2>{{ tenant.name }}</h2>
          </ion-label>
        </ion-item>
      }

      <ion-item lines="none" style="text-align: center; --min-height: 40px">
        <ion-label color="medium">
          <small>Showing {{ availableTenants.length }} accounts</small>
        </ion-label>
      </ion-item>
    </crowdctrl-list>
  }
</crowdctrl-page>
